import {accountPaths} from '~/utils/services/paths';
import {$cpFetch} from '~/composables/useCpFetch';
import type {IWishlist} from '~/types';
import {useWishlistStore} from '~/stores';
import {useCpUser} from '~/composables/useCpUser';

export type IWishlistPayload = {
    title: string,
    description: string,
    default?: boolean,
    articleId?: string
    amount?: number,
}

export const getWishlists = () => {
    return $cpFetch<Array<IWishlist>>(accountPaths.wishlists(useCpUser().userEmail!));
};

export const createWishlist = (payload : IWishlistPayload) => {
    return $cpFetch<IWishlist>(accountPaths.wishlists(useCpUser().userEmail!), {
        method: 'POST',
        body: payload,
    });
};

export const updateWishlist = (payload : IWishlistPayload) => {
    return $cpFetch<IWishlist>(accountPaths.updateWishlist(useCpUser().userEmail!, useWishlistStore().getWishlistToEdit.id!), {
        method: 'PUT',
        body: payload,
    });
};

export const deleteWishlist = () => {
    return $cpFetch<IWishlist>(accountPaths.updateWishlist(useCpUser().userEmail!, useWishlistStore().getWishlistToEdit.id!), {
        method: 'DELETE',
    });
};
